import React from 'react';
import './App.css';
import SnakeGame from './components/SnakeGame';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <SnakeGame />
      </header>
    </div>
  );
}

export default App;
